import React from 'react'

const IconProfile = (props) => {
  return (
    <svg {...props} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M20.0001 17.8947C24.9416 17.8947 28.9474 13.8888 28.9474 8.94734C28.9474 4.00586 24.9416 0 20.0001 0C15.0586 0 11.0527 4.00586 11.0527 8.94734C11.0527 13.8888 15.0586 17.8947 20.0001 17.8947Z" fill="currentcolor"/>
    <path d="M19.9999 20C11.2797 20 4.21045 27.0693 4.21045 35.7895C4.21045 38.1148 6.09561 40 8.421 40H31.5789C33.9043 40 35.7894 38.1148 35.7894 35.7895C35.7894 27.0693 28.7201 20 19.9999 20Z" fill="currentcolor"/>
    </svg>
  )
}

export default IconProfile